import { render, staticRenderFns } from "./FacilityAdminCredentialsForm.vue?vue&type=template&id=2ac24fe6&scoped=true"
import script from "./FacilityAdminCredentialsForm.vue?vue&type=script&lang=js"
export * from "./FacilityAdminCredentialsForm.vue?vue&type=script&lang=js"
import style0 from "./FacilityAdminCredentialsForm.vue?vue&type=style&index=0&id=2ac24fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac24fe6",
  null
  
)

export default component.exports